// Keyboard Shortcuts — Houses
// ========================================================================
// Registers app-specific shortcuts using SeeMe.shortcuts (imported in index.js).
// ? (cheat sheet) is built-in from SeeMe.shortcuts itself.

(function () {
    'use strict';

    var sc = SeeMe.shortcuts;

    // ── Helpers ─────────────────────────────────────────────────────────

    function activeSheet() {
        return window.rfSheet && window.rfSheet.active();
    }

    function getTopbarInput() {
        return document.querySelector('#topbar-search input[name="q"]');
    }

    // ── Global ──────────────────────────────────────────────────────────

    // / — Focus topbar search
    sc.register('/', {
        handler: function () {
            var input = getTopbarInput();
            if (input) input.focus();
        },
        label: 'Focus search',
        section: 'Global'
    });

    // Cmd+K — Spotlight search
    sc.register('cmd+k', {
        handler: function () {
            SeeMe.spotlight.open();
        },
        label: 'Spotlight search',
        section: 'Global'
    });

    // ── Signal sheet ────────────────────────────────────────────────────
    // Detect the signal sheet by looking at the live DOM, not the URL —
    // the signal-detail sheet has `?sheet=...` but no dedicated path.

    function hasSignalSheet() {
        var sheet = activeSheet();
        return !!(sheet && sheet.querySelector('[data-signal-action]'));
    }

    function clickSignalAction(action) {
        var sheet = activeSheet();
        if (!sheet) return;
        var btn = sheet.querySelector('[data-signal-action="' + action + '"]');
        if (btn) btn.click();
    }

    sc.register('r', {
        handler: function () { clickSignalAction('reviewed'); },
        label: 'Mark reviewed',
        section: 'Signal Sheet',
        when: hasSignalSheet
    });

    sc.register('a', {
        handler: function () { clickSignalAction('actionable'); },
        label: 'Mark actionable',
        section: 'Signal Sheet',
        when: hasSignalSheet
    });

    sc.register('m', {
        handler: function () { clickSignalAction('campaign_only'); },
        label: 'Mark campaign only',
        section: 'Signal Sheet',
        when: hasSignalSheet
    });

    sc.register('y', {
        handler: function () { clickSignalAction('skipped'); },
        label: 'Skip',
        section: 'Signal Sheet',
        when: hasSignalSheet
    });

    sc.register('n', {
        handler: function () { clickSignalAction('new'); },
        label: 'Reset to new',
        section: 'Signal Sheet',
        when: hasSignalSheet
    });

    sc.register('c', {
        handler: function () { clickSignalAction('create-prospect'); },
        label: 'Create prospect',
        section: 'Signal Sheet',
        when: hasSignalSheet
    });

    // ── Sheets: next action and snooze ──────────────────────────────────
    // Any sheet or detail page opts in through its markup, not here: `n` opens
    // the first visible `[data-next-action-trigger]`, `s` the first visible
    // snooze menu (`[data-snooze-preset]` items, `_acq_snooze_menu.html`).
    // Added as each sheet comes up; the lead, prospect, seller listing and
    // buyer lead sheets have `n`, the lead and prospect sheets `s`. Works on
    // the open sheet, or on the full detail page when no sheet is open. The
    // page can hold a hidden copy of a control, so take the first visible one.
    // Snooze menus are panel menus that move to <body> when they open, so the
    // open check looks at the whole document.

    function visibleIn(selector) {
        var scope = activeSheet() || document;
        var els = scope.querySelectorAll(selector);
        for (var i = 0; i < els.length; i++) {
            if (els[i].offsetParent !== null) return els[i];
        }
        return null;
    }

    // An open menu has moved to <body>, so the open state is read off the
    // .dropdown wrapper; clicking the toggle then would close it.
    function openDropdownFor(el) {
        var dropdown = el && el.closest('.dropdown');
        var toggle = dropdown && dropdown.querySelector('[data-dropdown]');
        if (toggle && !dropdown.classList.contains('show')) toggle.click();
    }

    // Next week is hidden when it is tomorrow, so 1-4 count the shown ones.
    function openSnoozePresets() {
        return document.querySelectorAll('.dropdown-menu.show [data-snooze-preset]:not([hidden])');
    }

    // The presets are hidden until the menu opens, so find the clock trigger
    // through the menu that holds them.
    function snoozeTrigger() {
        var scope = activeSheet() || document;
        var presets = scope.querySelectorAll('[data-snooze-preset]');
        for (var i = 0; i < presets.length; i++) {
            var dropdown = presets[i].closest('.dropdown');
            var toggle = dropdown && dropdown.querySelector('[data-dropdown]');
            if (toggle && toggle.offsetParent !== null) return toggle;
        }
        return null;
    }

    ['1', '2', '3', '4'].forEach(function (key, i) {
        sc.register(key, {
            handler: function () {
                var presets = openSnoozePresets();
                if (presets[i]) presets[i].click();
            },
            label: 'Pick snooze preset ' + key,
            section: 'Snooze',
            when: function () { return openSnoozePresets().length > 0; },
            priority: 10
        });
    });

    sc.register('s', {
        handler: function () {
            if (!openSnoozePresets().length) openDropdownFor(snoozeTrigger());
        },
        label: 'Snooze',
        section: 'Sheets (where available)',
        when: function () { return !!snoozeTrigger(); }
    });

    // n — open the next-action editor with the cursor in the action text, so
    // ⌘↵ saves it.
    sc.register('n', {
        handler: function () {
            openDropdownFor(visibleIn('[data-next-action-trigger]'));
            setTimeout(function () {
                var input = document.querySelector('.dropdown-menu.show textarea[name="next_action"]');
                if (!input) return;
                input.focus();
                input.setSelectionRange(input.value.length, input.value.length);
            }, 50);
        },
        label: 'Edit next action',
        section: 'Sheets (where available)',
        when: function () { return !!visibleIn('[data-next-action-trigger]'); }
    });

    // ── Sheet ───────────────────────────────────────────────────────────

    // Cmd+Enter — Submit the form the cursor is in (sheet or page)
    sc.register('cmd+enter', {
        handler: function () {
            var el = document.activeElement;

            // Active form always wins — covers dropdown forms portaled to body,
            // sheet footers, page forms, etc.
            var focusedForm = el && el.closest('form');
            if (focusedForm) {
                focusedForm.requestSubmit();
                return;
            }

            // No focused form — fall back to the main form in the sheet body.
            var sheet = activeSheet();
            if (sheet) {
                var form = sheet.querySelector('.sheet__body form');
                if (form) form.requestSubmit();
            }
        },
        label: 'Submit form',
        section: 'Global',
        allowEditing: true
    });

    // ── Spotlight config ────────────────────────────────────────────────

    SeeMe.spotlight.configure({
        url: '/topbar/search/',
        placeholder: 'Search deals, rentals, contacts...'
    });

    // The topbar search endpoint returns a shell with hx-trigger="load" divs
    // that lazy-load results per type. Spotlight inserts via innerHTML so HTMX
    // never sees them. Process HTMX on the results container after each insert.
    var observer = new MutationObserver(function (mutations) {
        for (var i = 0; i < mutations.length; i++) {
            var target = mutations[i].target;
            if (target.classList && target.classList.contains('spotlight__results')) {
                htmx.process(target);
                return;
            }
        }
    });
    observer.observe(document.body, { childList: true, subtree: true });

    // Remove the "Searching..." loader once results arrive inside spotlight.
    // Same logic as topbar-search.js: remove on first real result, 3s fallback.
    // Note: sub-requests use hx-swap="outerHTML" so e.detail.target is detached
    // from the DOM after swap — can't use contains(). Just check on every swap.
    var spotlightLoaderTimeout;
    document.body.addEventListener('htmx:afterSwap', function () {
        var spotlight = document.querySelector('.spotlight__results');
        if (!spotlight) return;

        var loader = spotlight.querySelector('#topbar-search-loading');
        if (!loader) return;

        if (spotlight.querySelector('.rf-list-group-item--action')) {
            clearTimeout(spotlightLoaderTimeout);
            loader.remove();
        } else if (!spotlightLoaderTimeout) {
            spotlightLoaderTimeout = setTimeout(function () {
                spotlightLoaderTimeout = null;
                var l = spotlight.querySelector('#topbar-search-loading');
                if (l && !spotlight.querySelector('.rf-list-group-item--action')) {
                    l.innerHTML = '<div class="rf-list-item-content"><div class="rf-list-item-description">No results found</div></div>';
                } else if (l) {
                    l.remove();
                }
            }, 3000);
        }
    });

})();
